import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

import { SPEC_COURSE_LESSON_MODE } from 'common.components/spec-course-lesson-view/typings';

import { getSpecCourseLessonMode } from '../spec-course.lesson-view/selectors';

import { SpecCourseResultsFinishedNoStudentsStub } from './__finished-no-students-stub/results__finished-no-students-stub';
import { SpecCourseResultsInviteStudentsStub } from './__invite-students-stub/results__invite-students-stub';
import { SpecCourseLessonResults } from './__lesson-results/results__lesson-results';
import { SpecCourseResultsNoStudentsStub } from './__no-students-stub/results__no-students-stub';
import { SpecCourseResultsNotAvailableStub } from './__not-available-stub/results__not-available-stub';

interface Props {
    awardsRef: React.RefObject<HTMLDivElement>;
    resultsRef: React.RefObject<HTMLDivElement>;
}

// eslint-disable-next-line complexity
export const SpecCourseResults = (props: Props) => {
    const { awardsRef, resultsRef } = props;
    const { classId } = useParams<Record<string, string>>();
    const mode = useSelector((store) => getSpecCourseLessonMode(store, { classId }));

    switch (mode) {
        case SPEC_COURSE_LESSON_MODE.NO_STUDENTS:
            return <SpecCourseResultsNoStudentsStub />;
        case SPEC_COURSE_LESSON_MODE.INVITE_STUDENTS:
            return <SpecCourseResultsInviteStudentsStub />;
        case SPEC_COURSE_LESSON_MODE.NO_STUDENTS_FINISHED:
        case SPEC_COURSE_LESSON_MODE.NOT_SOLVED:
            return <SpecCourseResultsFinishedNoStudentsStub />;
        case SPEC_COURSE_LESSON_MODE.CONTROL_WORK_ASSIGNED:
            return <SpecCourseResultsNotAvailableStub />;
        case SPEC_COURSE_LESSON_MODE.LESSON_ASSIGNED:
        case SPEC_COURSE_LESSON_MODE.LESSON_IN_PROGRESS:
        case SPEC_COURSE_LESSON_MODE.LESSON_FINISHED:
        case SPEC_COURSE_LESSON_MODE.CONTROL_WORK_IN_PROGRESS:
        case SPEC_COURSE_LESSON_MODE.CONTROL_WORK_FINISHED:
        case SPEC_COURSE_LESSON_MODE.WAITING_FOR_RESULTS:
            return <SpecCourseLessonResults awardsRef={awardsRef} resultsRef={resultsRef} />;
        default:
            return null;
    }
};
